import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {color} from "@khanacademy/wonder-blocks-tokens";
import {mediaQueries} from "@khan/shared-styles";

import {SerifHeadingMedium} from "./typography/typography.ts";

type Props = {
    kind: "Headline";
    headline: string;
    scrollId?: string;
};

export default class Headline extends React.Component<Props> {
    render(): React.ReactNode {
        const {headline, scrollId} = this.props;
        return (
            <View style={styles.container} data-scroll-id={scrollId}>
                <View style={styles.content}>
                    <SerifHeadingMedium tag="h2" style={styles.header}>
                        {headline}
                    </SerifHeadingMedium>
                </View>
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        width: "100%",
        margin: "0 0 80px 0",
        ":focus": {
            outline: 0,
        },
    },
    content: {
        color: color.offBlack,
        width: "100%",
        maxWidth: 1152,
        padding: "0 64px",
        margin: "122px auto 120px auto",
        alignItems: "center",
        [mediaQueries.mdOrSmaller]: {
            paddingLeft: 20,
            paddingRight: 20,
        },
        [mediaQueries.md]: {
            maxWidth: 550,
        },
        [mediaQueries.lgOrLarger]: {
            maxWidth: 810,
        },
    },
    header: {
        // The -40px margin that is made up for with 40px padding is
        // so that when we scroll to this element, there is 40px of
        // space above the heading.
        margin: "-40px auto 0",
        padding: "40px 0 0",
        textAlign: "center",
        maxWidth: 800,

        [mediaQueries.md]: {
            marginBottom: 71,
            fontSize: 44,
        },
        [mediaQueries.smOrSmaller]: {
            marginBottom: 8,
        },
    },
});
